var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconGuestNotAttending = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_add_circle_24px",
    d: "M8,2a6,6,0,1,0,6,6A6,6,0,0,0,8,2Zm3,6.6H8.6V11H7.4V8.6H5V7.4H7.4V5H8.6V7.4H11Z",
    transform: "translate(-5.3 6) rotate(-45)",
    fill: "#c89c91"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconGuestNotAttending);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-guest-not-attending.db7d17a86bec753b921b600bf02dd9ff.svg";